import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { CookieConsentService, LanguageService } from 'src/app/services';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass, NgIf } from '@angular/common';

@Component({
    selector: 'app-cookies',
    templateUrl: './cookies.component.html',
    styleUrls: ['./cookies.component.scss'],
    standalone: true,
    imports: [
        NgClass,
        NgIf,
        TranslateModule,
    ],
})
export class CookiesComponent implements OnDestroy {
  isEnglish: boolean;
  subscription: Array<Subscription>;
  cookieConsent: string;

  constructor(
    private languageService: LanguageService,
    public cookieService: CookieConsentService
  ) {
    this.cookieConsent = this.cookieService.get();
    this.isEnglish = this.languageService.get() === 'fr-FR' ? false : true;

    this.subscription = [
      this.languageService.langEmitter.subscribe(lang => {
        this.isEnglish = lang === 'fr-FR' ? false : true
      }),
      this.cookieService.cookieConsentEmitter.subscribe(cookieVal => {
        this.cookieConsent = cookieVal;
      })
    ];
  }

  ngOnDestroy(): void {
    this.subscription.forEach((sub) => sub.unsubscribe());
  }
}
